/* Current date, opted in with <time data-nl-current-date> inside a Shopify section.
   Uses the reader's local calendar in English, matching the article's long date.
   The element's Liquid-rendered text/datetime remain the no-JS fallback.
   Updates at local midnight (including DST) and on visibility/pageshow restore.
   No injected nodes. Static dates have no hook and are never queried or changed.
   One shared loader; per-element init guards and section-unload teardown. */
(function () {
  'use strict';
  if (window.__nlCurrentDateLoaded) return;
  window.__nlCurrentDateLoaded = true;
  var instances = new Map();

  function init(element) {
    if (instances.has(element)) return;
    var timer;
    function refresh() {
      window.clearTimeout(timer);
      var now = new Date();
      element.textContent = now.toLocaleDateString('en-US', {
        month: 'long', day: 'numeric', year: 'numeric'
      });
      element.setAttribute('datetime', now.getFullYear() + '-' +
        String(now.getMonth() + 1).padStart(2, '0') + '-' +
        String(now.getDate()).padStart(2, '0'));
      var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      timer = window.setTimeout(refresh, midnight.getTime() - now.getTime() + 100);
    }
    function visible() {
      if (document.visibilityState === 'visible') refresh();
    }
    instances.set(element, function () {
      window.clearTimeout(timer);
      document.removeEventListener('visibilitychange', visible);
      window.removeEventListener('pageshow', refresh);
    });
    document.addEventListener('visibilitychange', visible);
    window.addEventListener('pageshow', refresh);
    refresh();
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-nl-current-date]').forEach(function (element) {
      if (element.closest('[id^="shopify-section-"]')) init(element);
    });
  }
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (destroy, element) {
      if (event.target.contains(element)) {
        destroy();
        instances.delete(element);
      }
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else initAll(document);
}());
